import { Media } from '../presentational/media';
import Skeleton from '../presentational/skeleton';

export default function SkeletonCharacterRaidProgression() {
	return (
		<div>
			<Media greaterThanOrEqual="md">
				<div className="slds-grid slds-wrap slds-m-bottom--medium">
					<div className="slds-size--1-of-2 slds-small-size--1-of-2 slds-medium-size--1-of-2 slds-large-size--1-of-2">
						<Skeleton width="40%" height={32} style={{ borderRadius: '0.25rem' }} />
					</div>
					<div className="slds-size--1-of-2 slds-small-size--1-of-2 slds-medium-size--1-of-2 slds-large-size--1-of-2">
						<Skeleton width="100%" height={32} style={{ borderRadius: '0.25rem' }} />
					</div>
				</div>
			</Media>
			<Media lessThan="md">
				<div className="slds-grid slds-wrap slds-m-bottom--medium">
					<div className="slds-size--1-of-2 slds-small-size--1-of-2">
						<Skeleton width="80%" height={32} style={{ borderRadius: '0.25rem' }} />
					</div>
					<div className="slds-grid slds-size--1-of-2 slds-grid--align-end slds-small-size--1-of-2">
						<Skeleton width={52} height={32} style={{ borderRadius: '0.25rem' }} />
					</div>
				</div>
			</Media>

			<div style={{ marginBottom: 32 }}>
				<Skeleton height={43} />
				<Skeleton variant="item" height={106} animate />
			</div>
		</div>
	)
}
